import { theme as defaultTheme } from '@bigcommerce/big-design-theme';
import styled, { css } from 'styled-components';
import { withMargins } from '../../mixins';
export const StyledBadge = /*#__PURE__*/styled.span.withConfig({
  displayName: "styled__StyledBadge",
  componentId: "sc-1oik56k-0"
})(["", ";color:", ";border-radius:", ";display:inline-block;font-size:", ";font-weight:", ";line-height:", ";text-align:center;text-transform:uppercase;vertical-align:middle;padding:0 ", ";", " ", " ", " ", " ", ""], withMargins(), _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.white;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.borderRadius.normal;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.helpers.remCalc(12);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.typography.fontWeight.semiBold;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.lineHeight.small;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing.xSmall;
}, _ref7 => {
  let {
    theme,
    variant
  } = _ref7;
  return variant === 'secondary' && css(["background-color:", ";"], theme.colors.secondary60);
}, _ref8 => {
  let {
    theme,
    variant
  } = _ref8;
  return variant === 'success' && css(["background-color:", ";"], theme.colors.success50);
}, _ref9 => {
  let {
    theme,
    variant
  } = _ref9;
  return variant === 'warning' && css(["color:", ";background-color:", ";"], theme.colors.secondary70, theme.colors.warning40);
}, _ref10 => {
  let {
    theme,
    variant
  } = _ref10;
  return variant === 'danger' && css(["background-color:", ";"], theme.colors.danger40);
}, _ref11 => {
  let {
    theme,
    variant
  } = _ref11;
  return variant === 'primary' && css(["background-color:", ";"], theme.colors.primary40);
});
StyledBadge.defaultProps = {
  theme: defaultTheme,
  variant: 'secondary'
};